import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

import Button from '../../components/Button';
import Footer from '../../components/Footer';
import Logo from '../../components/Logo';
import PublicPageLayout from '../../components/PublicPageLayout';
import Text from '../../components/Text';

const EmailSentImageContainer = styled.img`
    align-self: center;
    margin-bottom: 2.5em;
`;

const Center = styled.div`
    -ms-grid-row: 1;
    grid-area: content;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

const ResetPasswordEmailSent: React.FC = () => {
    const { t } = useTranslation();

    return (
        <>
            <Helmet>
                <title>{t('resetPasswordEmailSent.confirmationMessage')}</title>
            </Helmet>
            <PublicPageLayout>
                <Center>
                    <Logo />
                    <Text type="H700" style={{ marginTop: '1.875rem' }}>
                        {t('resetPasswordEmailSent.confirmationMessage')}
                    </Text>
                    <EmailSentImageContainer
                        src="assets/email_sent.svg"
                        alt={t('resetPasswordEmailSent.confirmationMessage')}
                    />
                    <Link to="/login" style={{ textDecoration: 'none' }}>
                        <Button
                            aspect="primary"
                            size="large"
                            type="submit"
                            data-testid="button"
                            text={t('resetPasswordEmailSent.returnToLogin')}
                        />
                    </Link>
                </Center>
                <Footer />
            </PublicPageLayout>
        </>
    );
};

export default ResetPasswordEmailSent;
